/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `POST /api/rulesSet/{id}/devices`
 */
export interface IdDevicesPostRequest {
  /**
   * 设备类目
   */
  deviceTypeId?: number;
  /**
   * 设备列表
   */
  deviceList?: number[];
  /**
   * 数据属性列表
   */
  dataPropertyList?: number[];
  /**
   * 是否统一计算
   */
  unifiedCompute?: boolean;
  /**
   * Y轴倍率默认值，仅限数值型规则使用
   */
  yMagnificationValue?: number;
  /**
   * 累积量起始值默认值，仅限数值型规则使用
   */
  cumulativeStartValue?: number;
  id: string;
}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `POST /api/rulesSet/{id}/devices`
 */
export type IdDevicesPostResponse = number;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `POST /api/rulesSet/{id}/devices`
 */
type ApiRulesSetIdDevicesPostRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/rulesSet/{id}/devices',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `POST /api/rulesSet/{id}/devices`
 */
const apiRulesSetIdDevicesPostRequestConfig: ApiRulesSetIdDevicesPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/rulesSet/{id}/devices',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiRulesSetIdDevicesPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `POST /api/rulesSet/{id}/devices`
 */
export const apiRulesSetIdDevicesPost = /*#__PURE__*/ (
  requestData: IdDevicesPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<IdDevicesPostResponse>(prepare(apiRulesSetIdDevicesPostRequestConfig, requestData), ...args);
};

apiRulesSetIdDevicesPost.requestConfig = apiRulesSetIdDevicesPostRequestConfig;

/* prettier-ignore-end */
